import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const settlementFileDownloadReq = (tokens: any, reqBody: any, _fileName: string) => {
  return fetch(`${sitConfig(tokens).baseUrl}${APIEndPoints.getDownloadSettlementsReport}`, {
    method: 'POST',
    headers: sitConfig(tokens).headers,
    body: JSON.stringify(reqBody),
  })
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { settlementFileDownloadReq }
